import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=38021442&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=38021442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38021442",
  null
  
)

export default component.exports